angular.module('contactModule').component('contactOpenhouse', {
	templateUrl: 'contactOpenhouse/contactOpenhouse.html',
	bindings: {
		user: '<',
		type: '<',
		companyPhone: '<',
		errorMessages: '<',
		successMessage: '<',
		subTitle: '<',
		address: '<',
		isMobile: '<',
		openhouse: '<',
		onSubmitForm: '&',
		openhouses: '<'
	},
	controller: ['$timeout', '$window', 'PubSub', '$element', 'crResourcesService', function($timeout, $window, PubSub, $element, crResourcesService) {
		var ctrl = this;
		this.showDisclaimer = false;

		this.$onInit = () => {
			this.showCompanyPhone = true;
			this.showName = true;
			this.showEmail = true;
			this.showPhone = true;
			this.showMessage = true;

			this.user.openhouse = {
				from: this.openhouse.from,
				to: this.openhouse.to
			};

			this.updateUserMessage();
		};

		this.$postLink = () => {
		};

		this.submit = () => {
			// this.manualSubmitted = true;
			this.onSubmitForm({form: this.form});
		};

		this.updateUserMessage = () => {
			this.user.message = '';//`I would like to attend open house for ${this.address} on ${this.openhouse.display}` ;
		};
	}]
});